import React, { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Textarea from '../Form/Fields/Textarea';
import RichTextEditor from '../Form/Fields/RichTextEditor';
import Switcher from '../Form/Fields/Switcher';
import ImageUploader from '../Form/Fields/ImageUploader';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

export default function HelpArticleModal({ show, onClose, onSaved, categoryId, article = null }) {
    const isEdit = article != null;
    const [isLoading, setIsLoading] = useState(false);

    const defaultValues = {
        title: article?.title ?? '',
        excerpt: article?.excerpt ?? '',
        image: article?.imageUrl ?? null,
        content: article?.content ?? '',
        published: article?.published ?? true,
    };

    const onSubmit = (data) => {
        const { image, ...rest } = data;
        const payload = { ...rest, categoryId };
        // image is a File when a new one was picked, null when it was removed, or the
        // unchanged existing URL string when the field wasn't touched at all.
        if (typeof image !== 'string') {
            payload.removeImage = image == null;
        }

        const formData = new FormData();
        formData.append('article', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
        if (image instanceof File) {
            formData.append('image', image);
        }

        const url = isEdit
            ? `${API_BASE_URL}/api/v1/backoffice/help/articles/${article.id}`
            : `${API_BASE_URL}/api/v1/backoffice/help/articles`;

        setIsLoading(true);
        axios({ method: isEdit ? 'put' : 'post', url, data: formData, withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } })
            .then(() => {
                toast.success(isEdit ? 'Article mis à jour.' : 'Article créé.');
                onSaved();
                onClose();
            })
            .catch(() => toast.error('Une erreur est survenue.'))
            .finally(() => setIsLoading(false));
    };

    return (
        <Modal
            id="helpArticleModal"
            title={isEdit ? "Modifier l'article" : 'Nouvel article'}
            show={show}
            onClose={onClose}
            icon={faFileLines}
            iconBg="#e0e7ff"
            iconColor="#4338ca"
            classSize="modal-lg"
            footer={
                <Button isLoading={isLoading} loadingMessage="Enregistrement ..." type="submit" form="helpArticleForm" className="modal-btn-primary">
                    {isEdit ? 'Enregistrer' : 'Créer'}
                </Button>
            }
        >
            <Form id="helpArticleForm" onSubmit={onSubmit} defaultValues={defaultValues} key={article?.id ?? 'new'}>
                <div className="mb-3">
                    <label className="cdm-field-label">Titre <span className="text-danger">*</span></label>
                    <InputText
                        name="title"
                        placeholder="ex: Comment ajouter un produit ?"
                        validationRules={{ required: 'Le titre est requis' }}
                    />
                </div>
                <div className="mb-3">
                    <label className="cdm-field-label">Extrait</label>
                    <Textarea name="excerpt" placeholder="Court résumé affiché dans les listes et la recherche" />
                </div>
                <div className="mb-3">
                    <label className="cdm-field-label">Image de couverture</label>
                    <ImageUploader name="image" />
                </div>
                <div className="mb-3">
                    <label className="cdm-field-label">Contenu <span className="text-danger">*</span></label>
                    <RichTextEditor
                        name="content"
                        placeholder="Corps de l'article ..."
                        validationRules={{ required: 'Le contenu est requis' }}
                    />
                </div>
                <div className="mb-3 d-flex align-items-center gap-2">
                    <label className="cdm-field-label mb-0">Publié</label>
                    <Switcher name="published" id="helpArticlePublished" size="mini" />
                </div>
            </Form>
        </Modal>
    );
}
